<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import SidePanel from "@/components/SidePanel/SidePanel.vue";
import SidePanelContent from "@/components/SidePanel/SidePanelContent.vue";
import { cockpitSessionUrl } from "@/components/utils/cockpitUrls";
import { boardTypeName } from "@/model/baseTypes";
import { useBoardStore } from "@/store/board";
import { useBoardConfigStore } from "@/store/boardConfig";

const { t } = useI18n();

const title = computed(() =>
  t("boardConfig.title", { board: t(boardTypeName(useBoardStore().currentBoard().type)) }),
);
const url = computed(() => {
  const board = useBoardStore().currentBoard();
  return cockpitSessionUrl({
    boardType: board.type,
    boardId: board.type === "flex" ? board.flexType.id : undefined,
    noNav: true,
  });
});
</script>

<template>
  <div class="board-config-panel" data-ignore-click @scroll.stop>
    <SidePanel
      side="left"
      :active="useBoardConfigStore().active"
      name="boardConfig"
      resizable
      @close="useBoardConfigStore().toggle(false)"
    >
      <SidePanelContent :title>
        <iframe :title :src="url" />
      </SidePanelContent>
    </SidePanel>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/z-index";

.board-config-panel {
  position: relative;
  z-index: z-index.$menu;

  :deep(.scrollable) {
    overflow: hidden;
  }

  iframe {
    border: none;
    width: 100%;
    height: 100%;
  }
}
</style>
